// LeavePermissionReport

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { LEAVE_PERMISSION_REPORT } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const LeavePermissionReport = () => {

    const [leavePermissionReportData, setLeavePermissionReportData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const LeavePermissionReportColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "leave_type",
            Header: "Leave Type",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "request_raised_date",
            Header: "Req Raised Date/Time",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "from_date",
            Header: "Req Date/Time",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "approved_date",
            Header: "Approved Date/Time",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "approved_by",
            Header: "Approved By",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Leave Permission Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={LeavePermissionReportColumns}
                data={leavePermissionReportData}
                setData={setLeavePermissionReportData}
                setTotalCount={setTotalRecords}
                url={LEAVE_PERMISSION_REPORT}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isFromToDateRequired={true}
            />
        </div >
    );
}

export default LeavePermissionReport;